<template>
  <div class="content-warpper">
    <div class="warpper-title flex align-center justify-between">
      <div>
        <i class="iconfont iconjigou2"></i>
        机构介绍
      </div>

    </div>
    <div class="padding-sm">

      <el-form
          :model="orgForm"
          :rules="rules"
          ref="orgForm"
          label-width="140px"
          class="demo-orgForm"
      >
        <el-form-item label="机构名称" prop="org">
          <el-input
              disabled
              v-model="orgForm.org"
              placeholder="请输入机构名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="LOGO" prop="logo">
          <el-upload
              class="avatar-uploader"
              :action="upUrl + '/admin/upload'"
              :name="'image'"
              :data="fileData"
              :show-file-list="false"
              accept="image/*"
              :on-success="handleAvatarSuccess"
          >
            <img v-if="orgForm.logo" :src="imgUrl + orgForm.logo" class="avatar"/>
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="机构介绍" prop="desc">
          <el-input
              v-model="orgForm.desc"
              placeholder="请输入机构介绍"
              type="textarea"
              rows="3"
          ></el-input>
        </el-form-item>
        <el-form-item label="机构地址" prop="address">
          <el-input
              v-model="orgForm.address"
              placeholder="请输入机构介绍"
              type="textarea"
              rows="3"
          ></el-input>
        </el-form-item>
        <el-form-item label="联系人" prop="name">
          <el-input
              v-model="orgForm.name"
              placeholder="请输入联系人"
          ></el-input>
        </el-form-item>
        <el-form-item label="联系人手机号" prop="phone">
          <el-input
              v-model="orgForm.phone"
              placeholder="请输入联系人手机号"
          ></el-input>
        </el-form-item>
        <el-form-item label="联系人邮箱" prop="email">
          <el-input
              v-model="orgForm.email"
              placeholder="请输入联系人邮箱"
          ></el-input>
        </el-form-item>
        <el-form-item label="官网地址">
          <el-input
              v-model="orgForm.web"
              placeholder="请输入官网地址"
          ></el-input>
        </el-form-item>
        <el-form-item label="机构环境">
          <div class="flex align-start flex-wrap">
            <el-upload
                class="avatar-uploader"
                :action="upUrl + '/admin/upload'"
                :name="'image'"
                :data="fileData"
                :show-file-list="false"
                accept="image/*"
                :on-success="handleDescSuccess"
            >
              <i class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
            <div class="margin-left desc-img" v-for="(item,index) in orgForm.img" :key="index">
              <i class="el-icon-delete " @click="deletaImg(index)"></i>
              <img :src="imgUrl + item" class="avatar"/>
            </div>
          </div>

        </el-form-item>
        <el-form-item>
          <el-button
              type="primary"
              class="submit-btn"
              @click="submitForm('orgForm',0)"
          >提交
          </el-button>

        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import {UPFILE, IMGURL} from "@/config/index";
import {orgFind} from "@/api/common";
import {getDescInfo,setDescInfo} from "@/api/practiceBase";

export default {
  name: "organizationAdd",

  data() {
    // 手机号验证
    var checkPhone = (rule, value, callback) => {
      const phoneReg = /^1[0-9]{10}$/;
      if (!value) {
        return callback(new Error("手机号码不能为空"));
      }
      setTimeout(() => {
        if (!Number.isInteger(+value)) {
          callback(new Error("请输入数字值"));
        } else {
          if (phoneReg.test(value)) {
            callback();
          } else {
            callback(new Error("手机号码格式不正确"));
          }
        }
      }, 100);
    };
    return {
      orgForm: {
        org:'',
        logo: '',
        desc: '',
        address: '',
        name: '',
        phone: '',
        email: '',
        web: '',
        img: [],
      },
      rules: {
        logo: [{required: true, message: "请上传机构logo", trigger: "change"}],
        desc: [{required: true, message: "请输入机构简介", trigger: "blur"}],
        address: [{required: true, message: "请输入机构地址", trigger: "blur"}],
        name: [{required: true, message: "请输入联系人", trigger: "blur"}],
        phone: [{required: true, validator: checkPhone, trigger: "blur"}],
        email: [{required: true, message: "请输入邮箱地址", trigger: "blur"},
          {type: "email", message: "请输入正确的邮箱地址", trigger: "blur"}],
      }
    };
  },
  computed: {
    fileData() {
      return {
        u_token: this.$store.state.token2
      };
    },
    upUrl() {
      return UPFILE
    },
    imgUrl() {
      return IMGURL
    }
  },
  created() {
    this.id = this.$route.query.id;
    this.$emit(
        "setIndex",
        this.$route.path,
        "当前位置：机构管理 > 机构介绍",
        false
    );
    this.getDetail()
  },
  methods: {
    async getDetail() {
      let _data = await orgFind()
      this.orgForm.org = _data.data.org_name
      let _data2 = await getDescInfo()
      if(_data2.data){
        this.orgForm = {
          logo: _data2.data.logo,
          desc: _data2.data.desc,
          address: _data2.data.address,
          name: _data2.data.name,
          phone: _data2.data.phone,
          email: _data2.data.email,
          web: _data2.data.site_url,
          img: _data2.data.env_img.split(','),
        }
      }
    },
    handleAvatarSuccess(res) {
      if (res.code === 1002) {
        this.orgForm.logo = res.data.path
        this.$refs.orgForm.validateField('logo')
      } else {
        this.$message.error(res.data)
      }
    },

    handleDescSuccess(res) {
      if (res.code === 1002) {
        this.orgForm.img.push(res.data.path)
      } else {
        this.$message.error(res.data)
      }
    },
    deletaImg(index){
      this.$confirm('您确定要删除该图片吗？', '温馨提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.orgForm.img.splice(index,1)
      }).catch(() => {
      });

    },

    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.submitOrg()
        }
      });
    },
    async submitOrg() {
      let _state = await setDescInfo(
          this.orgForm.logo,
          this.orgForm.desc,
          this.orgForm.name,
          this.orgForm.phone,
          this.orgForm.address,
          this.orgForm.email,
          this.orgForm.img.join(','),
          this.orgForm.web,
      )
      this.$message.success(_state.msg)
    },

    back() {
      this.$router.go(-1);
    }
  },
  watch: {

  },
  filters: {

  }
};
</script>

<style scoped lang="scss">
.content-warpper {
  .apply-title {
    text-align: center;
    font-size: 32px;
    color: #009688;
    padding: 30px 30px 50px;
  }

  .apply-item-title {
    font-size: 18px;
  }
}

.autoAddressClass {
  li {
    i.el-icon-search {
      margin-top: 11px;
    }

    .mgr10 {
      margin-right: 10px;
    }

    .title {
      text-overflow: ellipsis;
      overflow: hidden;
    }

    .address {
      line-height: 1;
      font-size: 12px;
      color: #b4b4b4;
      margin-bottom: 5px;
    }
  }
}
.desc-img{
  position: relative;
  i{
    position: absolute;
    top: -10px;
    right: -10px;
    background: #e4393c;
    color: #fff;
    padding: 10px;
    border-radius: 100%;
    font-size: 14px;
    cursor: pointer;
  }
}
</style>



